export default function DTD_Introduction() {
  return (
    <div>
      <h1>DTD_Introduction</h1>
      <p>This is the DTD_Introduction component.</p>
    </div>
  );
}